__turbopack_context__.v({
  "breathe": "MPnlna_breathe",
  "enter": "MPnlna_enter",
  "label": "MPnlna_label",
  "mark": "MPnlna_mark",
  "root": "MPnlna_root",
  "sweep": "MPnlna_sweep",
});
